module.exports = __webpack_public_path__ + "media/images/responsive/costumes/icon_crown-e8b2195c6ed86310309abd385d255ad0.svg";